import React, { useEffect, useState } from 'react';
import Loader from '../global/loader';
import swal from 'sweetalert2';
import { getGreenFeeMasterByDate, getGreenFeeMasterByCalenderID } from '../api/teeTimeAPI';
import { NavLink } from 'react-router-dom';
import bannerLogo from '../../assets/images/OGR_Login_logo.png';

const RateCard = () => {
    const [loading, setLoading] = useState(false);
    const [greenFeeChart, setGreenFeeChart] = useState([]);
    const [selectedFee, setSelectedFee] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        getGreenFee();
    }, []);

    const getGreenFee = async () => {
        try {
            setLoading(true);
            const master = await getGreenFeeMasterByDate(new Date()); 
            setGreenFeeChart(master.GreenFeeList);
            
            setLoading(false);
        } catch (err) {
            setLoading(false);
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
        }
    };

    const createRateChart = (subCategoryId, hole, isWeekend) => {
        const greenFee = greenFeeChart.find(i => 
            i.SubCategoryID == subCategoryId && 
            i.Hole == hole && 
            i.IsWeekend == isWeekend
        );
        if (greenFee) {
            setSelectedFee(greenFee);
            setShowModal(true);
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedFee(null);
    };

    // Rate card entries data
    // const rateCardEntries = [
    //     { id: 1, particular: "OGR Member", holes: 18, days: "All Day", onClick: () => createRateChart(1, 18, 'N') },
    //     { id: 3, particular: "OGR Member", holes: 9, days: "All Day", onClick: () => createRateChart(1, 9, 'N') },
    //     { id: 5, particular: "Residential Member", holes: 18, days: "All Day", onClick: () => createRateChart(2, 18, 'N') },
    //     { id: 7, particular: "Residential Member", holes: 9, days: "Weekday", onClick: () => createRateChart(2, 9, 'N') },
    //     { id: 9, particular: "Members Guest", holes: 18, days: "Weekday", onClick: () => createRateChart(5, 18, 'N') },
    //     { id: 10, particular: "Members Guest", holes: 18, days: "Weekends", onClick: () => createRateChart(5, 18, 'Y') },
    //     { id: 11, particular: "Members Guest", holes: 9, days: "Weekday", onClick: () => createRateChart(5, 9, 'N') },
    //     { id: 12, particular: "Members Guest", holes: 9, days: "Weekends", onClick: () => createRateChart(5, 9, 'Y') },
    //     { id: 13, particular: "Room Guest", holes: 18, days: "Weekday", onClick: () => createRateChart(4, 18, 'N') },
    //     { id: 14, particular: "Room Guest", holes: 18, days: "Weekends", onClick: () => createRateChart(4, 18, 'Y') },
    //     { id: 15, particular: "Room Guest", holes: 9, days: "Weekday", onClick: () => createRateChart(4, 9, 'N') },
    //     { id: 16, particular: "Room Guest", holes: 9, days: "Weekends", onClick: () => createRateChart(4, 9, 'Y') },
    //     { id: 17, particular: "Walking Guest", holes: 18, days: "Weekday", onClick: () => createRateChart(3, 18, 'N') },
    //     { id: 18, particular: "Walking Guest", holes: 18, days: "Weekends", onClick: () => createRateChart(3, 18, 'Y') },
    //     { id: 19, particular: "Walking Guest", holes: 9, days: "Weekday", onClick: () => createRateChart(3, 9, 'N') },
    //     { id: 20, particular: "Walking Guest", holes: 9, days: "Weekends", onClick: () => createRateChart(3, 9, 'Y') },
    // ];

    return (
        <>
            {/* Navigation */}
            <nav className="navbar navbar-default" role="navigation">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-10 padding-lr0">
                            <div className="navbar-brand">
                                <NavLink  to="/">
                                    <img id="asideBrandLogo" alt="Logo" src={bannerLogo} height="35"/>
                                </NavLink>
                                <div>Oxford Golf Resort<small> Tee Time Booking</small></div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            <div className="container">
                <div className="row padding-t15">
                    <div className="col-xs-12 text-center">
                        <h3 className="text-header">Rate Chart For Green Fee</h3>
                    </div>
                    <div className="col-xs-12">
                        <div className="messageHolder"></div>
                    </div>
                </div>

                {/* Listing */}
                <div className="row">
                    <div className="col-xs-12">
                        {loading ? <Loader /> : (
                            <div className="panel panel-default panel-club">
                                <table id="tblGreenFee" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Particular</th>
                                            <th>Holes</th>
                                            <th style={{ width: "10%" }}>Days</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {greenFeeChart.map(entry => (
                                            <tr key={entry.ID} onClick={() => createRateChart(entry.SubCategoryID
                                                , entry.Hole, entry.IsWeekend)}>
                                                <td>{entry.UserType}</td>
                                                <td>{entry.Hole}</td>
                                                <td>{entry.Type}</td>
                                            </tr>
                                            // <tr key={entry.id} onClick={entry.onClick}>
                                            //     <td>{entry.particular}</td>
                                            //     <td>{entry.holes}</td>
                                            //     <td>{entry.days}</td>
                                            // </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>

                {/* Modal */}
                {showModal && selectedFee && (
                    <div className="modal" tabIndex="-1" role="dialog" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content margin-t150">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={closeModal}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h5 className="modal-title">OGR {selectedFee.SubCategoryName}</h5>
                                </div>
                                <div className="modal-body">
                                    <div id="ModalHolder">
                                        <div className="row">
                                            <div className="col-xs-6 padding-l15">
                                                <h6>Hole:</h6>
                                            </div>
                                            <div className="col-xs-6 padding-r15">
                                                <input 
                                                    id="txtHole" 
                                                    className="form-control" 
                                                    readOnly 
                                                    value={selectedFee.Hole} 
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-6 padding-l15">
                                                <h6>Day:</h6>
                                            </div>
                                            <div className="col-xs-6 padding-r15">
                                                <input 
                                                    id="txtDay" 
                                                    className="form-control" 
                                                    readOnly 
                                                    value={selectedFee.IsWeekend === "Y" ? "Weekends" : "Weekday"} 
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-6 padding-l15">
                                                <h6>Green Fee:</h6>
                                            </div>
                                            <div className="col-xs-6 padding-r15">
                                                <input 
                                                    id="txtGreenFee" 
                                                    className="form-control" 
                                                    readOnly 
                                                    value={`₹ ${selectedFee.GreenFee}`} 
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-6 padding-l15">
                                                <h6>Cart:</h6>
                                            </div>
                                            <div className="col-xs-6 padding-r15">
                                                <input 
                                                    id="txtCart" 
                                                    className="form-control" 
                                                    readOnly 
                                                    value={`₹ ${selectedFee.Cart}`} 
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-6 padding-l15">
                                                <h6>Caddy:</h6>
                                            </div>
                                            <div className="col-xs-6 padding-r15">
                                                <input 
                                                    id="txtCaddy" 
                                                    className="form-control" 
                                                    readOnly 
                                                    value={`₹ ${selectedFee.Caddy}`} 
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-6 padding-l15">
                                                <h6>Taxes:</h6>
                                            </div>
                                            <div className="col-xs-6 padding-r15">
                                                <input 
                                                    id="txtTax" 
                                                    className="form-control" 
                                                    readOnly 
                                                    value={`₹ ${selectedFee.Tax}`} 
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-6 padding-l15">
                                                <h6><strong>Total:</strong></h6>
                                            </div>
                                            <div className="col-xs-6 padding-r15">
                                                <strong>
                                                    <input 
                                                        id="txtTotal" 
                                                        className="form-control" 
                                                        readOnly 
                                                        value={`₹ ${selectedFee.Total}`} 
                                                    />
                                                </strong>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-6 padding-l15">
                                                <h6>Remarks:</h6>
                                            </div>
                                            <div className="col-xs-6 padding-r15">
                                                <h6 id="txtRemark">{selectedFee.Remark}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default RateCard;